module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_04.7d12b4a4.jpg";